import { RelationshipType } from "../../../../../../../Wrap/Constants/Enums/Customer/RelationshipType";
import { OrganisationMember } from "../../../../../../../Wrap/Models/Models/Customer/OrganisationMember";

export const checkTrusteeIsSmallerThanSettlor = (
    originData: OrganisationMember[],
    selectedRoles: RelationshipType[]
): boolean => {
    let originRelationshipArr = [];
    originData.forEach((e) => {
        originRelationshipArr = originRelationshipArr.concat(e?.Relationships || []);
    });
    const trusteeNumber =
        (originRelationshipArr?.filter((ele) => ele == RelationshipType.IndividualTrustee || ele == RelationshipType.CorporateTrustee)?.length || 0) +
        (selectedRoles?.filter((ele) => ele == RelationshipType.IndividualTrustee || ele == RelationshipType.CorporateTrustee)?.length || 0);
    const settlorNumber =
        (originRelationshipArr?.filter((ele) => ele == RelationshipType.Settlor)?.length || 0) +
        (selectedRoles?.filter((ele) => ele == RelationshipType.Settlor)?.length || 0);
    return trusteeNumber <= settlorNumber;
};

export const checkFinalRelationship = (
    originData: OrganisationMember[],
    selectedRoles: RelationshipType[],
    targetRelationship: RelationshipType
) => {
    let originRelationshipArr = [];
    originData.forEach((e) => {
        originRelationshipArr = originRelationshipArr.concat(e?.Relationships || []);
    });
    const number =
        (originRelationshipArr?.filter((ele) => ele == targetRelationship)?.length || 0) +
        (selectedRoles?.filter((ele) => ele == targetRelationship)?.length || 0);
    return number == 0;
};

export const checkSettlorEqualOrGreaterThanTwo = (
    originData: OrganisationMember[],
    selectedRoles: RelationshipType[]
): boolean => {
    let originRelationshipArr = [];
    originData.forEach((e) => {
        originRelationshipArr = originRelationshipArr.concat(e?.Relationships || []);
    });
    const number =
        (originRelationshipArr?.filter((ele) => ele == RelationshipType.Settlor)?.length || 0) +
        (selectedRoles?.filter((ele) => ele == RelationshipType.Settlor)?.length || 0);
    return number >= 2;
};

export const checkFinalBeneficiary = (
    organisationMembers: OrganisationMember[]
) => {
    return organisationMembers?.filter(x => x.Relationships.includes(RelationshipType.Beneficiary)).length == 1
}
